import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { breakpoint } from '../../theme/breakpoint';
import { addSubPx, multiplyPx } from '../../styled/utils';
import { InputWrapper as SearchInputWrapper } from '../../form-elements/field/styles';

const halfPx = multiplyPx(0.5);
const add2px = addSubPx(2);
const add1px = addSubPx(1);

/* InputWrap height will cascade down to the input field and associated button height */
/* overrides for mobile side drawer margins and smaller mobile header version live here */

export const InputWrapper = styled.div`
  margin-bottom: 0;
  display: flex;

  input {
    padding: ${({ theme }) => `6px ${theme.spacing.small}`};
  }

  ${SearchInputWrapper} {
    margin-right: ${({ theme }) => halfPx(theme.spacing.tiny)};
  }

  ${breakpoint.desktop`
      min-width: 185px;
      width: auto;

      input {
        padding: ${({ theme }) =>
          `${add1px(theme.spacing.tiny)} ${theme.spacing.small} ${add2px(
            theme.spacing.tiny
          )}`}
      }
  `}

  ${({ $placement, theme }) =>
    $placement === 'mobileDrawer'
      ? `margin: ${theme.spacing.standard} ${theme.spacing.standard} 0`
      : `margin: 0;`};
`;

export const SearchIcon = styled(SVG)`
  display: block;
  width: 1em;
  height: 1em;
  fill: ${({ theme }) => theme.palette.link};
`;

export const SearchForm = styled.form`
  flex: 1;
  ${breakpoint.desktop`
    flex: none;
  `}
`;
